var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e73ETYlzdfe1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 800",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e73ETYlzdfe3-stroke",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e73ETYlzdfe3-stroke-0",
    offset: "0%",
    stopColor: "#e21dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e73ETYlzdfe3-stroke-1",
    offset: "100%",
    stopColor: "#f3a5ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e73ETYlzdfe4-stroke",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e73ETYlzdfe4-stroke-0",
    offset: "0%",
    stopColor: "#e21dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e73ETYlzdfe4-stroke-1",
    offset: "100%",
    stopColor: "#f3a5ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e73ETYlzdfe5-stroke",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e73ETYlzdfe5-stroke-0",
    offset: "0%",
    stopColor: "#e21dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e73ETYlzdfe5-stroke-1",
    offset: "100%",
    stopColor: "#f3a5ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e73ETYlzdfe6-stroke",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e73ETYlzdfe6-stroke-0",
    offset: "0%",
    stopColor: "#e21dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e73ETYlzdfe6-stroke-1",
    offset: "100%",
    stopColor: "#f3a5ed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0-1 800 800)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "400,250 250,550 550,550",
    fill: "none",
    stroke: "url(#e73ETYlzdfe3-stroke)",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412,250 262,550 562,550",
    opacity: 0.25,
    fill: "none",
    stroke: "url(#e73ETYlzdfe4-stroke)",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388,250 238,550 538,550",
    opacity: 0.25,
    fill: "none",
    stroke: "url(#e73ETYlzdfe5-stroke)",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,250 250,550 550,550",
    fill: "none",
    stroke: "url(#e73ETYlzdfe6-stroke)",
    strokeWidth: 16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.3e3e839804cf4de11dae8665ae0631ef.svg";
export { ForwardRef as ReactComponent };